import React from 'react';

const Backdrop = ({ show }) => (
    show ? <div className="Backdrop"></div> : null
)

export default Backdrop